var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},_vm._l((3),function(n){return _c('div',{key:n,class:("bounce" + n),style:({backgroundColor: _vm.color})})}))}
var staticRenderFns = []

export { render, staticRenderFns }